export const fonts = {
	fontFamily: 'MonumentGrotesk',
	fontFamilyTitle: 'MonumentGrotesk',
}
